module.exports = __webpack_public_path__ + "img/comments-solid.08515c4f.svg";